<template>
  <div class="cabinet-table">
    <div class="cabinet-table__head">
      <div class="cabinet-table__cell">№</div>
      <div class="cabinet-table__cell">Название</div>
      <div class="cabinet-table__cell">Комментарий</div>
      <div
        class="cabinet-table__cell"
        v-if="hasEditCabinet" />
      <div
        class="cabinet-table__cell"
        v-if="hasDeleteCabinet" />
    </div>
    <button
      type="button"
      class="cabinet-table__row"
      v-for="{
        id, name, comment,
      } in cabinetList"
      v-bind:key="id"
      v-on:click="onEditCabinet(id)">
      <div
        data-label="№"
        class="cabinet-table__cell number" />
      <div
        data-label="Название"
        class="cabinet-table__cell">{{ name }}</div>
      <div
        data-label="Комментарий"
        class="cabinet-table__cell">{{ comment }}</div>
      <div
        class="cabinet-table__cell"
        data-label="Редактировать"
        v-if="hasEditCabinet">
        <button
          type="button"
          v-on:click.stop="onEditCabinet(id)">
          <div class="cabinet-table__icon-edit" />
        </button>
      </div>
      <div
        class="cabinet-table__cell"
        data-label="Удалить"
        v-if="hasDeleteCabinet">
        <button
          type="button"
          v-on:click.stop="onDeleteCabinet(id)">
          <div class="cabinet-table__icon-delete" />
        </button>
      </div>
    </button>
  </div>
</template>
<script>
import { List } from 'monet';

/**
 * @description Таблица пациентов.
 * @type {any}
 */
export default {
  computed: {
    /**
     * @description Имеет возможность удалять кабинеты.
     * @returns {boolean}
     */
    hasDeleteCabinet() {
      return this.actions.includes('delete');
    },
    /**
     * @description Имеет возможность редактировать кабинеты.
     * @returns {boolean}
     */
    hasEditCabinet() {
      return this.actions.includes('edit');
    },
  },
  data() {
    return {
      /**
       * @description Изображения кабинетов.
       * @returns {any[]}
       */
      imageList: [],
    };
  },
  methods: {
    /**
     * @description Обработать редактирование кабинета.
     * @param {number} id Идентификатор кабинета.
     * @returns {void}
     */
    onEditCabinet(id) {
      if (this.hasEditCabinet) {
        this.$emit('edit-cabinet', id);
      }
    },
    /**
     * @description Обработать удаление кабинета.
     * @param {number} id Идентификатор кабинета.
     * @returns {void}
     */
    onDeleteCabinet(id) {
      this.$emit('delete-cabinet', id);
    },
  },
  props: {
    /**
     * @description Допустимые действия.
     * @type {string[]}
     */
    actions: { required: true, type: Array },
    /**
     * @description Список кабинетов.
     * @type {List<Cabinet>}
     */
    cabinetList: {
      required: true,
      type: List,
    },
  },
};
</script>
<style lang="scss">
.cabinet-table {
  counter-reset: counterEmployees;
  margin: 35px 0 0 0;
  &__head,
  &__row {
    width: 100%;
    text-align: left;
    display: grid;
    grid-template-columns: 40px 258px 2fr 43px fit-content(43px);
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    padding: 10px 0;
  }
  &__row {
    cursor: pointer;
    border-bottom: 1px solid #eaeff3;
    padding: 12px 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__cell {
    padding: 0 8px;
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.number:after {
      counter-increment: counterEmployees;
      content: counter(counterEmployees);
    }
    &__color {
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }
    &__image {
      height: 25px;
      width: 25px;
      border-radius: 50%;
      object-fit: cover;
      padding: 0;
    }
  }
  &__icon {
    &-edit {
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .cabinet {
    &-table {
      &__head,
      &__row {
        grid-template-columns: 40px 1fr 1fr 43px fit-content(43px);
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .cabinet {
    &-table {
      &__head {
        display: none;
      }
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 10px;
        margin: 0 0 20px 0;
      }
      &__cell {
        display: flex;
        justify-content: space-between;
        text-align: right;
      }
      &__cell:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
      }
    }
  }
}
</style>
